import { toGqlId } from "@src/api/formatters/shopify";
import { ProductPickerThunkParams } from "@src/components/targeting/components/expressions/context";
import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { getCartTargetingExpressionList } from "@src/store/slices/cartTargeting/selectors";
import {
  openProductPicker,
  setProductPickerSelectedProducts,
} from "@src/store/slices/productPicker";
import { ProductPickerSelectedProduct } from "@src/store/slices/productPicker/types";

export const openCartTargetingProductPicker = createAsyncThunk<
  void,
  ProductPickerThunkParams
>(
  "productPicker/openCartTargetingProductPicker",
  async (params, { dispatch, getState }) => {
    const {
      selectedProductIds,
      expressionsListIndex,
      expressionsIndex,
      targetingId,
    } = params;

    const cartTargetingId = targetingId ?? "";

    if (!cartTargetingId) {
      return;
    }

    dispatch(
      openProductPicker({
        type: "cartTargeting",
        expressionsListIndex,
        expressionsIndex,
        targetingId: cartTargetingId,
      })
    );

    if (selectedProductIds === "") {
      dispatch(setProductPickerSelectedProducts([]));
    } else {
      const expressionsList =
        getCartTargetingExpressionList(cartTargetingId)(getState());
      const originalQuery =
        expressionsList[expressionsListIndex]?.queries[expressionsIndex];
      const variantObject = originalQuery?.value;

      const formattedProductIds: string[] = selectedProductIds.split(",");

      const baseProductsFormatted: ProductPickerSelectedProduct[] =
        formattedProductIds.map((p) => {
          const foundProductDisplay = originalQuery?.displayData?.[p];

          const productVariants = variantObject?.[p];
          const includedVariants = productVariants
            ?.filter((v) => v.inclusionType === "include")
            .map((v) => toGqlId(v.variantId, "ProductVariant"));

          const selectedVariantIds =
            !includedVariants || includedVariants.length === 0
              ? undefined
              : includedVariants;
          const totalVariantCount = productVariants?.length;

          return {
            id: p,
            title: foundProductDisplay?.title || "",
            image: foundProductDisplay?.image || undefined,
            handle: "",
            requiresSellingPlan: false,
            selectedVariantIds,
            totalVariantCount,
          };
        });
      dispatch(setProductPickerSelectedProducts(baseProductsFormatted));
    }
  }
);
